export default {
  nav: {
    home: "Ana Sayfa",
    services: "Hizmetler",
    about: "Hakkımızda",
    contact: "İletişim",
    book: "Rezervasyon",
  },
  hero: {
    badge: "Kur. 2012 — 3.800'den Fazla Müşteri",
    line1: "Daha Temiz Bir Alan,",
    line2: "Daha Berrak Bir Zihin.",
    sub: "Evler ve işyerleri için profesyonel temizlik hizmetleri — titizlik, özen ve detaycı bir bakışla.",
    btn1: "Temizlik Rezervasyonu",
    btn2: "Hizmetlerimiz",
    scroll: "Kaydır",
  },
  partners: "Ortaklarımız",
  stats: {
    exp: "Yıllık Deneyim",
    clients: "Hizmet Verilen Müşteri",
    satisfaction: "Memnuniyet Oranı",
    support: "7/24 Destek",
  },
  services: {
    pageTitle: "Hizmetlerimiz — Cleaning Holding",
    pageMeta: "Cleaning Holding'in tüm lüks temizlik hizmetlerini keşfedin.",
    pageSubtitle:
      "Her hizmet aynı mükemmellik taahhüdüyle sunulur — titiz, kapsamlı ve size özel.",
    label: "Ne Sunuyoruz",
    title: "Hizmetlerimiz",
    ctaTitle: "Başlamaya Hazır mısınız?",
    ctaSub: "Bugün ücretsiz teklif için bizimle iletişime geçin.",
    ctaBtn: "Teklif İste",
    learnMore: "Daha Fazla",
    viewAll: "Tüm Hizmetler",
    residential: {
      title: "Konut Temizliği",
      subtitle: "Eviniz — Mükemmel",
      desc: "Yaşam tarzınıza özel lüks ev temizliği.",
      fullDesc:
        "Her evi kendimizinki gibi temizleriz. Uzmanlarımız premium eko-sertifikalı ürünler kullanır.",
      f1: "Düzenli Bakım Temizliği",
      f2: "Oda Oda Derin Temizlik",
      f3: "Mutfak ve Banyo Hijyeni",
      f4: "Cam ve Yüzey Parlatma",
    },
    commercial: {
      title: "Ticari Temizlik",
      subtitle: "İlham Veren Mekanlar",
      desc: "Ofisinizi ve tesislerinizi en iyi şekilde yansıtın.",
      fullDesc:
        "İlk izlenim önemlidir. Ofislerinizi, perakende alanlarınızı ve tesislerinizi kusursuz tutuyoruz.",
      f1: "Ofis Temizliği",
      f2: "Mağaza Temizliği",
      f3: "Etkinlik Sonrası Temizlik",
      f4: "Düzenli Tesis Bakımı",
    },
    deep: {
      title: "Derin Temizlik",
      subtitle: "Baştan Sona",
      desc: "Baştan sona kapsamlı temizlik.",
      fullDesc:
        "Standart temizlik yetmediğinde. Derin temizliğimiz her köşe, çatlak ve yüzeyi kapsar.",
      f1: "Tam Mülk Derin Temizliği",
      f2: "Beyaz Eşya İç Temizliği",
      f3: "Fayans Derz Yenileme",
      f4: "Havalandırma Temizliği",
    },
    move: {
      title: "Taşınma Temizliği",
      subtitle: "Temiz Başlangıç ve Bitiş",
      desc: "Yeni başlangıç veya temiz bir ayrılış.",
      fullDesc:
        "Taşınmak zaten yeterince stresli. Temizliği bize bırakın, önemli olana odaklanın.",
      f1: "Tam Mülk Hijyeni",
      f2: "Dolap ve Çekmece Temizliği",
      f3: "Duvar Lekesi Giderme",
      f4: "Kiraya Vermeye Hazır Temizlik",
    },
    construction: {
      title: "İnşaat Sonrası Temizlik",
      subtitle: "Altındaki Güzelliği Ortaya Çıkar",
      desc: "İnşaat sonrası uzman temizlik hizmeti.",
      fullDesc:
        "İnşaat toz, moloz ve kalıntı bırakır. Şantiyeyi taşınmaya hazır bir mekana dönüştürüyoruz.",
      f1: "Toz ve Moloz Temizliği",
      f2: "Yüzey ve Zemin Parlatma",
      f3: "Cam Temizliği",
      f4: "Son İnceleme Detaylandırma",
    },
    recurring: {
      title: "Düzenli Paketler",
      subtitle: "Tutarlı Mükemmellik",
      desc: "Haftalık, iki haftalık ve aylık paketler.",
      fullDesc:
        "Standardı koruyun. Paketlerimiz mekanınızın her zaman misafir kabulüne hazır olmasını sağlar.",
      f1: "Haftalık / 2 Haftada Bir / Aylık",
      f2: "Özel Temizlik Ekibi",
      f3: "Kişiselleştirilmiş Kontrol Listesi",
      f4: "Öncelikli Zamanlama",
    },
  },
  process: {
    label: "Nasıl Çalışır",
    title: "Sürecimiz",
    step1: {
      title: "Online Rezervasyon",
      desc: "Hizmetinizi ve tercih ettiğiniz tarihi dakikalar içinde seçin.",
    },
    step2: {
      title: "Onaylıyoruz",
      desc: "Ekibimiz rezervasyonunuzu 2 saat içinde inceler ve onaylar.",
    },
    step3: {
      title: "Temizliyoruz",
      desc: "Eğitimli uzmanlar tüm ekipmanla zamanında gelir.",
    },
    step4: {
      title: "Keyif Çıkarın",
      desc: "Sonuçları inceleyin ve tertemiz mekanınızın tadını çıkarın.",
    },
  },
  cta: {
    title: "Tertemiz Bir Alan İçin Hazır mısınız?",
    sub: "Bugün ücretsiz teklif alın — hiçbir yükümlülük yok.",
    btn: "Ücretsiz Teklif",
  },
  about: {
    pageTitle: "Hakkımızda — Cleaning Holding",
    pageMeta:
      "Cleaning Holding hakkında bilgi edinin — 12 yıllık premium temizlik deneyimi.",
    label: "Hikayemiz",
    title: "Hakkımızda",
    subtitle:
      "On yıllık özveri, binlerce memnun müşteri ve değişmeyen tek standart — mükemmellik.",
    since: "2012'den Beri",
    storyTitle: "Güven Üzerine İnşa Edilmiş",
    story1:
      "Cleaning Holding, 2012 yılında basit ama güçlü bir inançla kuruldu: her mekan özen ve titizlikle ele alınmayı hak eder. Küçük bir konut temizlik şirketi olarak başlayan yolculuğumuz, binlerce ev ve işyerinin güvendiği tam hizmet veren bir şirkete dönüştü.",
    story2:
      "Son 12 yılda güvenilirlik, gizlilik ve kaliteye olan bağlılığımızla bir itibar oluşturduk. Müşterilerimiz bizi sadece kiralamıyor — bize güveniyor.",
    quote:
      "Sadece mekanları temizlemiyoruz — her ortama huzur, düzen ve gurur duygusu geri getiriyoruz.",
    valuesLabel: "Bizi Harekete Geçiren",
    valuesTitle: "Temel Değerlerimiz",
    teamLabel: "Mükemmelliğin Arkasındaki İnsanlar",
    teamTitle: "Ekibimizle Tanışın",
    ctaTitle: "Birlikte Çalışalım",
    ctaSub: "Cleaning Holding farkını ilk hizmetten itibaren hissedin.",
    ctaBtn: "İletişime Geçin",
    values: {
      v1: {
        title: "Premium Kalite",
        desc: "Yalnızca en iyi eko-sertifikalı ürünleri kullanır ve her işte titiz kalite kontrolleri uygularız.",
      },
      v2: {
        title: "Güven ve Dürüstlük",
        desc: "Mekanınıza güvenle davet edebileceğiniz, tam olarak incelenmiş ve sigortalı profesyoneller.",
      },
      v3: {
        title: "Güvenilirlik",
        desc: "Her seferinde zamanında. Programınıza saygı duyar ve tutarlı sonuçlar sunarız.",
      },
      v4: {
        title: "Çevre Bilinci",
        desc: "Ailenizi, evcil hayvanlarınızı ve çevreyi koruyan sürdürülebilir temizlik çözümleri.",
      },
    },
    team: { exp: "deneyim" },
  },
  contact: {
    pageTitle: "İletişim — Cleaning Holding",
    pageMeta: "Ücretsiz teklif için Cleaning Holding ile iletişime geçin.",
    label: "İletişime Geçin",
    title: "İletişim",
    subtitle:
      "Tertemiz bir alan için hazır mısınız? Bize ulaşın, 2 saat içinde ücretsiz teklifle geri dönelim.",
    formTitle: "Mesaj Gönderin",
    formSub: "2 iş saati içinde yanıt vereceğiz.",
    name: "Ad Soyad",
    email: "E-posta",
    phone: "Telefon Numarası",
    service: "İhtiyaç Duyulan Hizmet",
    message: "Mesaj",
    selectService: "Hizmet seçin...",
    send: "Gönder",
    successTitle: "Teşekkürler!",
    successMsg:
      "Mesajınız alındı. Ekibimizden biri en kısa sürede sizinle iletişime geçecek.",
    infoTitle: "İletişim Bilgileri",
    infoSub: "Sizi duymaktan her zaman memnuniyet duyarız.",
    whyTitle: "Neden Biz",
    why1: "Ücretsiz danışmanlık ve teklif",
    why2: "2 saat içinde yanıt",
    why3: "Tam sigortalı ve incelenmiş ekip",
    why4: "Esnek zamanlama",
    address: "Adres",
    phoneLabel: "Telefon",
    emailLabel: "E-posta",
    hoursLabel: "Çalışma Saatleri",
    services: {
      residential: "Konut Temizliği",
      commercial: "Ticari Temizlik",
      deep: "dasuptaveba, Derin Temizlik",
      moveinout: "dalageba, Taşınma Temizliği",
      postconstruction: "İnşaat Sonrası Temizlik",
      recurring: "Düzenli Paket",
    },
  },
};
